import classNames from "classnames";
import React from "react";

/**
 * Base rectangular skeleton block — the atomic building block for all skeletons.
 *
 * @param {string|number} width   — CSS width  (default: '100%')
 * @param {string|number} height  — CSS height (default: 'var(--skeleton-text-height)')
 * @param {string}        radius  — 'sm' | 'md' | 'lg' | 'full' (default: 'md')
 * @param {boolean}       animate — pulse animation (default: true)
 * @param {string}        className — extra classNames
 * @param {object}        style   — extra inline styles
 */
const SkeletonBlock = ({
  width = "100%",
  height = "var(--skeleton-text-height)",
  radius = "md",
  animate = true,
  className,
  style,
  ...rest
}) => {
  const radiusClass = {
    sm: "skeleton--rounded-sm",
    md: "",
    lg: "skeleton--rounded-lg",
    full: "skeleton--circle",
  }[radius];

  return (
    <div
      className={classNames(
        "skeleton",
        radiusClass,
        { "skeleton--no-animate": !animate },
        className,
      )}
      style={{
        width: typeof width === "number" ? `${width}px` : width,
        height: typeof height === "number" ? `${height}px` : height,
        flexShrink: 0,
        ...style,
      }}
      aria-hidden="true"
      {...rest}
    />
  );
};

export default SkeletonBlock;
